import { render, staticRenderFns } from "./payment-link.vue?vue&type=template&id=3a4c4146&scoped=true"
import script from "./payment-link.vue?vue&type=script&lang=js"
export * from "./payment-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4c4146",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a4c4146')) {
      api.createRecord('3a4c4146', component.options)
    } else {
      api.reload('3a4c4146', component.options)
    }
    module.hot.accept("./payment-link.vue?vue&type=template&id=3a4c4146&scoped=true", function () {
      api.rerender('3a4c4146', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/online-transaction/payment-link.vue"
export default component.exports